module.exports = __webpack_public_path__ + "img/right.6081a07c.gif";